import { TriangleAlert } from 'lucide-react';
import { Link } from 'react-router';

type ErrorBannerProps = {
  title: string;
  message?: string;
  action?: { text: string; href: string };
};

export function ErrorBanner(props: ErrorBannerProps) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-8">
      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <TriangleAlert className="h-8 w-8 text-destructive" />
        </div>
        <h2 className="mb-2 text-xl font-semibold">{props.title}</h2>

        {props.message && <p className="mb-6 text-sm text-muted-foreground">{props.message}</p>}

        {props.action && (
          <Link
            to={props.action.href || '/'}
            className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {props.action.text}
          </Link>
        )}
      </div>
    </div>
  );
}
